<template>
  <PModalBox
    :header="senderIsTlc ? 'Email text preview' : 'The Norwegian Transparency Act: Supplier questionnaire'"
    :open-dialog="openDialog"
    @close-dialog="$emit('closeDialog')"
    size="small"
  >
    <template #content>
      <div v-if="senderIsTlc">
        <v-row justify="start">
          <v-col cols="6">
            <v-autocomplete
              v-model="businessRelationship"
              :items="items"
              @update:model-value="fetchCustomerEmail"
              density="compact"
              variant="underlined"
            >
              <template #prepend>
                <p class="mt-2">View email sent to</p>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-divider class="mb-10" />
        <v-row>
          <v-col>
            <h2>The Norwegian Transparency Act: Supplier questionnaire</h2>
            <p class="mt-5 text-left" v-dompurify-html:email="emailText" />
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <p v-dompurify-html:email="emailText" class="text-left" />
      </div>
    </template>
    <template #rightbutton>
      <PPrimaryButton @click="$emit('closeDialog')">Close</PPrimaryButton>
    </template>
  </PModalBox>
</template>

<script setup lang="ts">
import { ref, computed, onBeforeMount } from "vue";
import { useUserProfileStore } from "@/stores/userProfileStore";
import { useSenderStore } from "@/stores/sender";
import { useSnackBarStore } from "@/stores/snackBarStore";
import { getCustomerEmail, getSupplierEmail } from "@/services/emailService";
import PModalBox from "@/components/custom/PModalBox.vue";
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";

const userProfileStore = useUserProfileStore();
const senderStore = useSenderStore();
const snackBarStore = useSnackBarStore();
const businessRelationship = ref("Suppliers");
const items = ["Suppliers", "Business Partners"];
const emailText = ref("");
const selectedCompany = computed(() => userProfileStore.trustGroup.company);

const props = defineProps<{
  senderIsTlc: boolean;
  openDialog: boolean;
}>();

defineEmits<{
  (e: "closeDialog"): void;
}>();

onBeforeMount(async () => {
  if (props.senderIsTlc) {
    await fetchCustomerEmail();
  } else {
    emailText.value = await getSupplierEmail(senderStore.contextId);
  }
});

async function fetchCustomerEmail(): Promise<void> {
  try {
    emailText.value = await getCustomerEmail(
      selectedCompany.value.companyName,
      businessRelationship.value == "Business Partners"
    );
  } catch (error) {
    snackBarStore.showError();
  }
}
</script>
